import React from 'react';

import LinkButton from '@atlaskit/button/link';

const LinkButtonDiscoveryExample = (): React.JSX.Element => {
	return (
		<LinkButton appearance="discovery" href="https://atlassian.com/">
			Discovery link button
		</LinkButton>
	);
};

export default LinkButtonDiscoveryExample;
